import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const StyledTitle = styled.h1`
    margin: 0;
    display: flex;
    align-items: center;
    font-size: 24px;
    line-height: 40px;
`;

const Title = (props) => {
    const { style, title } = props;

    return (
        <StyledTitle style={ style }>
            { title }
        </StyledTitle>
    );
};

Title.propTypes = {
    style: PropTypes.object,
    title: PropTypes.string.isRequired,
};

export default Title;



// WEBPACK FOOTER //
// ./src/components/ui/general/Title.js